import { TfsContext } from "Presentation/Scripts/TFS/TFS.Host.TfsContext";
import Utils_String = require("VSS/Utils/String");

export namespace WorkItemRichTextHelper {
    /**
     * Get base HTML for rich text editors
     * @param tfsContext Unused
     * @param disableViewPortScaling If set, add meta tag to disable scaling
     * @param additionalStyles Additional CSS styles to inject
     */
    export function getPageHtml(tfsContext?: TfsContext, disableViewPortScaling?: boolean, additionalStyles?: string): string {
        const styles = `<style>
html, body
{
    height: 100%;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
}
html {
    overflow: hidden;
}
body
{
    font-family: Segoe UI, Helvetica Neue, Helvetica, Arial, Verdana;
    color: #222222;
    background-color: #ffffff;
    font-size: 14px;
    word-break: break-word;
    margin:0;
    padding: 5px;
    box-sizing: border-box;
    overflow: auto;
}

body.invalid
{
    background-color: #ffc;
}

P
{
    line-height: 1.5em;
    margin: 0;
}

body.watermark {
    color: #999999;
    font-style: italic;
}

img 
{ 
    max-width: 100%; 
}

a, a:visited {
    color: #007acc;
}


a.mention-link {
    text-decoration: none;
}

.mention-widget-workitem {
    background: rgba(244, 244, 244, 1);
    padding: 2px .333em;
    display: inline;
    word-break: break-word;
    margin: 0 1px;
    border-radius: 2px;
    line-height: 24px;
    font-style: normal;
    font-weight: normal;
    border-left: 2px solid transparent;
}

.mention-widget-workitem-no-access {
    background: rgba(244, 244, 244, 1);
    padding: 2px .333em;
    display: inline;
    word-break: break-word;
    margin: 0 1px;
    border-radius: 2px;
    line-height: 24px;
    font-style: normal;
    font-weight: normal;
}

.mention-widget-workitem-typeid {
    color: rgba(16, 110, 190, 1);
}

.mention-widget-workitem-title {
    color: rgba(0, 0, 0, .9);
    font-weight: 600;
}

.mention-widget-workitem-state {
    border-left: 1px solid rgba(200, 200, 200, 1);
    padding: 0px 8px 0px 4px;
    display: inline-flex;
    align-items: center;
    margin: 4px 2px 4px 8px;
    line-height: 14px;
    vertical-align: bottom;
    color: rgba(0, 0, 0, .9);
    height: 16px;
}

.workitem-state-color {
    border: 3px solid transparent;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 0px 4px;
    background-clip: padding-box;
}

.mention-preview-person {
    color: rgba(16, 110, 190, 1);
    font-weight: bold;
    background-color: rgba(244, 244, 244, 1);
}

.mention-preview-me {
    color: rgba(218, 10, 0, 1);
}

.mention-preview-person-clickable {
    cursor: pointer;
}

.mention-widget {
    color: $communication-foreground;
    cursor: pointer;
}

.mention-widget * {
    cursor: pointer;
}

.mention-card {
    box-shadow: 0 0 20px gray;
}

.work-item-type-icon-host {
    display: inline-block;
}

.work-item-type-icon {
    min-width: 14px;
    display: inline;
}

.secondary-text {
    color: rgba(0, 0, 0, .55)
}

.work-item-type-icon-no-tooltip {
    margin-right: 5px;
}

.mention-widget-item {
    background: rgba(244, 244, 244, 1);
    padding: 0 .333em;
    display: inline;
    word-break: break-word;
}

.mention-widget-typeid {
    color: rgba(16, 110, 190, 1);
}

.mention-widget-title {
    color: rgba(0, 0, 0, .9)
}

${additionalStyles || ""}
</style>`;

        let metaTags = "";

        if (disableViewPortScaling) {
            metaTags += `<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">`;
        }

        return "<head>" +
            metaTags +
            styles +
            "</head>";
    }

    // Function to check if rich text editor html has only white space
    export function isHtmlVisuallyBlank(htmlInput: string): boolean {
        const html = $.parseHTML(htmlInput);
        let isEmpty = true;

        $.each(html, function (i, el) {
            isEmpty = ((el.textContent !== undefined && el.textContent.trim() === Utils_String.empty) &&
                (el.innerHTML === undefined || (el.innerHTML !== undefined && (el.tagName !== "IMG" && el.innerHTML.indexOf("img") === -1 && el.innerHTML.indexOf("li") === -1))));
            if (!isEmpty) {
                return isEmpty;
            }
        });
        return isEmpty;
    }
}